"use strict";

exports.__esModule = true;
exports.RouterContext = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var RouterContext = /*#__PURE__*/_react.default.createContext(null);

exports.RouterContext = RouterContext;

if (process.env.NODE_ENV !== 'production') {
  RouterContext.displayName = 'RouterContext';
}